import React from 'react';
import { useParams } from 'react-router-dom';
import { Container, Row, Col } from 'react-bootstrap';
import services from '../servicedata.json';
import NNavbar from './navbar';
import Callback from './callback';
import Footer from './footer';
import '../styles/servicetype.css';

import landingimage from '../media/services/service_landing.jpg';
import vat from '../media/services/vat.jpg';
import payroll from '../media/services/payroll.jpg';
import accountingbookkeeping from '../media/services/accountingbookkeeping.jpg';
import dataanalytics from '../media/services/dataanalytics.jpg';
import internalaudit from '../media/services/internalaudit.jpg';
import cfo from '../media/services/cfo.jpg';
import auditliaison from '../media/services/auditliason.jpg';
import amlcompliance from '../media/services/amlcompliance.jpg';



const ServiceType = () => {
  const { serviceKey } = useParams();
  const service = services[serviceKey];

  if (!service) return <p className="text-center">Service not found</p>;

  

  return (
    <>
    <NNavbar />
    <div className="service-type-section">
      <div
        className="service-hero"
        style={{
          backgroundImage: `linear-gradient(rgba(255,255,255,0.8), rgba(255,255,255,0.8)), url(${landingimage})`,
        }}
      >
        <Container>
          <h2 className="service-hero-title text-center">
            Our <span className="highlight">Services</span>
          </h2>
        </Container>
      </div>

      <Container className="py-5">
        <Row className="align-items-stretch service-card">
          <Col md={6} className="p-0">
            <img src={serviceKey==="vatandcorporatetax"?vat:serviceKey==="accountingandbookkeeping"?accountingbookkeeping:serviceKey==="payroll"?payroll:serviceKey==="dataanalyticsandbi"?dataanalytics:serviceKey==="interalaudit"?internalaudit:serviceKey==="cfosupport"?cfo:serviceKey==="auditliaison"?auditliaison:amlcompliance} alt={service.title} className="service-img" />
          </Col>
          <Col
            md={6}
            className="text-white service-content p-4 d-flex flex-column justify-content-center"
          >
            <h3 className="service-title">{service.title}</h3>
            <p className="service-description">{service.description}</p>
            {service.content.map((section, index) => (
              <div key={index} className="mb-3">
                <h5 className="section-title">{section.title}</h5>
                <p className="section-description">{section.description}</p>
              </div>
            ))}
          </Col>
        </Row>
      </Container>
    </div>
    <Callback />
    <Footer />
    </>
  );
};

export default ServiceType;
